<div class="email-tpl-dialog">
  <div class="email-tpl-dialog__header">
    <span class="email-tpl-dialog__title">{{ isEdit ? 'Edit Email Template' : 'Logo Upload' }}</span>
    <button mat-icon-button class="info-close-btn" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="email-tpl-dialog__body" [formGroup]="form">
    <div class="email-tpl-dialog__upload-area">
      <button type="button" class="email-tpl-dialog__upload-btn" (click)="fileRef.click()"
        [disabled]="isSubmitting">
        <mat-icon>cloud_upload</mat-icon>
        {{ form.get('fileName')?.value ? 'Change File' : 'Select File' }}
      </button>
      <span class="email-tpl-dialog__upload-hint">Allowed file types are png, jpg and jpeg</span>
      @if(form.get('fileName')?.value) {
        <div class="email-tpl-dialog__selected-file">
          <mat-icon class="email-tpl-dialog__file-check">check_circle</mat-icon>
          <span>{{ form.get('fileName')?.value }}</span>
        </div>
      }
      @if(form.get('emailLogo')?.touched && form.get('emailLogo')?.errors) {
        <span class="email-tpl-dialog__error">Logo is required</span>
      }
      <input #fileRef hidden type="file" accept="image/png, image/jpeg, image/jpg"
        (change)="onFileSelected($event)" />
    </div>

    <div class="email-tpl-dialog__field">
      <label class="email-tpl-dialog__label">Email Template*</label>
      <input type="text" class="email-tpl-dialog__input" placeholder="Email Template Name"
        formControlName="emailTemplateName" />
      @if(form.get('emailTemplateName')?.touched && form.get('emailTemplateName')?.errors) {
        <span class="email-tpl-dialog__error">Required</span>
      }
    </div>

    <div class="email-tpl-dialog__field">
      <label class="email-tpl-dialog__label">Email body header*</label>
      <input type="text" class="email-tpl-dialog__input" placeholder="Header"
        formControlName="emailBodyHeader" />
      @if(form.get('emailBodyHeader')?.touched && form.get('emailBodyHeader')?.errors) {
        <span class="email-tpl-dialog__error">Required</span>
      }
    </div>

    <div class="email-tpl-dialog__field">
      <label class="email-tpl-dialog__label">Email  Signature*</label>
      <input type="text" class="email-tpl-dialog__input" placeholder="Email Signature"
        formControlName="emailSignature" />
      @if(form.get('emailSignature')?.touched && form.get('emailSignature')?.errors) {
        <span class="email-tpl-dialog__error">Required</span>
      }
    </div>

    <div class="email-tpl-dialog__actions">
      <button type="button" class="email-tpl-dialog__submit-btn" (click)="onSubmit()"
        [class.spinner]="isSubmitting" [disabled]="isSubmitting">
        Submit
      </button>
    </div>
  </div>
</div>
